<template>
  <!-- 组件 -->
  <div>
    <div class="phone_title">
      <img v-if="!close" class="phone_menu" @click="menu()" src="/static/img/common/menu.png" alt="">
      <img v-if="close" @click="closeRotat()" class="phone_menu" src="/static/img/common/close.png" alt="" />
      <img class="logo_img" @click="selTabber(0)" src="/static/img/common/logoGreen.png" alt="" />
      <img class="rotation_icon" src="/static/img/common/searchPhone.png" alt="" />
    </div>
    <!-- NavMenu 导航菜单 -->
    <div class="rotation_title">
      <div class="rotation_left">
        <img class="logo_img" @click="selTabber(0)" src="/static/img/common/logo.png" alt="" />
      </div>
      <div class="rotation_middle">
        <div class="middle_each" 
        :class="{'middle_select':index===select}" 
        v-for="(item,index) in title" :key="index"
        @click="selTabber(index)" 
        >{{item}}</div>
      </div>
      <!-- <div class="rotation_right"> -->
        <!-- 请输入关键字 -->
        <div class="rotation_icon"></div>
        <!-- <img class="rotation_icon" src="/static/img/common/search.png" alt="" /> -->
      <!-- </div> -->
    </div>
    <div class="rotation_top" >
      <div class="rotation_left">
        <img class="logo_img" @click="selTabber(0)" src="/static/img/common/logoGreen.png" alt="" />
      </div>
      <div class="rotation_middle">
        <div class="middle_each" 
        :class="{'middle_select':index===select}" 
        v-for="(item,index) in title" :key="index"
        @click="selTabber(index)" 
        >{{item}}</div>
      </div>
      <div class="rotation_icon"></div>
      <!-- <img class="rotation_icon" src="/static/img/common/searchBlack.png" alt="" /> -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: "",
    },
    select: {
      type: Number,
      default: 0,
    },
    close:{
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      title:['首页','产品与服务','解决方案','新闻资讯','关于我们'],
    };
  },
  //过滤器
  filters: {},
  // 计算属性
  computed: {},
  // 监听器
  Watch: {},
  //生命周期 创建后
  created() {},
  // 挂载后
  mounted() {
    var title = document.querySelector('.rotation_title') // 获取元素加过度效果 （用ref也可以）
    var top = document.querySelector('.rotation_top')
    
    window.addEventListener('scroll',()=>{
    // 滚动大于500显示
      if(document.documentElement.scrollTop > 50 ){
          top.style.opacity = '1'
          top.style.transition = 'all 1s'
          title.style.opacity = '0'
          title.style.transition = 'all 1s'
      }else{
          top.style.opacity = '0'
          top.style.transition = 'all 1s'
          title.style.opacity = '1'
          title.style.transition = 'all 1s'
      }
    })
  },
  // 销毁前
  beforeDestroy() {},
  //自定义函数
  methods: {
    selTabber(id){
      this.$emit("selectTabber",id)
    },
    closeRotat(){
      this.$emit('closeRotat')
    },
    menu(){
      this.$router.push('/navigation')
    },
  },
};
</script>

<style scoped lang="scss">
@media screen and ( min-width: 1200px ) {
  .phone_title{
     display: none;
    .phone_menu{

    }
    .logo_img{
      
    }
    .rotation_icon{
      
    }
  }
  .rotation_title{
    position: fixed;
    top: 0;
    left: 50%;
    transform:translateX(-50%);
    width: 1200px;
    height: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 9;
    .rotation_left{
      .logo_img{
        width: 122px;
        height: 29px;
        
        cursor: pointer;
      }
    }
    .rotation_middle{
      display: flex;
      align-items: center;
      .middle_each{
        padding: 21px 20px 14px 20px;
        font-size: 18px;
        color: rgba(255, 255, 255, 1); 
        cursor: pointer;
      }
      .middle_select{
        background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.15) 100%);
        border-bottom: 1px solid #0EA049;
        box-sizing: border-box;
        font-weight: 600;
      }
    }
    .rotation_icon{
      width: 20px;
    }
  }
  .rotation_top{
    opacity: 0;
    position: fixed;
    top: 0;
    left: 50%;
    transform:translateX(-50%);
    width: 1920px;
    padding: 0 360px;
    box-sizing: border-box;
    height: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #FFFFFF;
    box-shadow: 0px 4px 4px rgba(48, 83, 58, 0.08);
    z-index: 10;
    .rotation_left{
      .logo_img{
        width: 120px;
        height: 29px;
        cursor: pointer;
      }
    }
    .rotation_middle{
      display: flex;
      align-items: center;
      .middle_each{
        padding: 21px 20px 14px 20px;
        font-size: 18px;
        color: #595959; 
        cursor: pointer;
      }
      .middle_select{
        background:#0EA049;
        font-weight: bold;
        color: #ffffff; 
        border: 1px solid #0EA049;
      }
    }
    .rotation_icon{
      width: 20px;
      height: 20px;
    }
  }
}
@media screen and ( min-width: 1000px ) and ( max-width: 1200px ) {
  .phone_title{
     display: none;
    .phone_menu{

    }
    .logo_img{
      
    }
    .rotation_icon{
      
    }
  }
  .rotation_title{
    position: fixed;
    top: 0;
    left: 50%;
    transform:translateX(-50%);
    width: 75rem;
    height: 3.75rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 9;
    .rotation_left{
      .logo_img{
        width: 7.625rem;
        height: 1.8125rem;
        cursor: pointer;
      }
    }
    .rotation_middle{
      display: flex;
      align-items: center;
      .middle_each{
        padding: 1.3125rem 1.25rem .875rem 1.25rem;
        font-size: 1.125rem;
        color: rgba(255, 255, 255, 1); 
        cursor: pointer;
      }
      .middle_select{
        background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.15) 100%);
        border-bottom: .0625rem solid #0EA049;
        box-sizing: border-box;
        font-weight: 600;
      }
    }
    .rotation_icon{
      width: 1.25rem;
    }
  }
  .rotation_top{
    opacity: 0;
    position: fixed;
    top: 0;
    left: 50%;
    transform:translateX(-50%);
    width: 120rem;
    padding: 0 22.5rem;
    box-sizing: border-box;
    height: 3.75rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #FFFFFF;
    box-shadow: 0rem .25rem .25rem rgba(48, 83, 58, 0.08);
    z-index: 10;
    .rotation_left{
      .logo_img{
        width: 7.5rem;
        height: 1.8125rem;
        cursor: pointer;
      }
    }
    .rotation_middle{
      display: flex;
      align-items: center;
      .middle_each{
        padding: 1.3125rem 1.25rem .875rem 1.25rem;
        font-size: 1.125rem;
        color: #595959; 
        cursor: pointer;
      }
      .middle_select{
        background:#0EA049;
        font-weight: bold;
        color: #ffffff; 
        border: .0625rem solid #0EA049;
      }
    }
    .rotation_icon{
      width: 1.25rem;
      height: 1.25rem;
    }
  }
}
@media screen and ( max-width: 1000px ) {
  .phone_title{
    position: fixed;
    top: 0;
    z-index: 99;
    width: 23.4375rem;
    height: 3.625rem;
    background-color: #F6FAFD;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 1.25rem;
    box-sizing: border-box;
    flex-direction: row-reverse;
    .phone_menu{
      width: 1.25rem;
    }
    .logo_img{
      width: 6rem;
    }
    .rotation_icon{
      width: 1.25rem;
      display: none;
    }
  }
  .rotation_title{
    display: none;
  }
  .rotation_top{
    display: none;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/rotation.vue